export default {
  SET_SERVICES: (state, { services }) => {
    state.services = services
  }
}
